import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
import PriorityListModal from "./PriorityListModal";
import { Link } from "react-router-dom";

export default function CTABand({
  overline = "Core AI Summit 2027",
  title = "Ready to be Part of It?",
  subtitle = "Join thousands of AI leaders, practitioners, and innovators in Niagara Falls.",
  primaryLabel = "Join the Priority List",
  secondaryLabel = "Partner With Core AI",
  secondaryHref = "/partner",
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section
        className="relative overflow-hidden"
        style={{ backgroundColor: "var(--surface)", borderTop: "1px solid var(--border)" }}
        data-testid="cta-band"
      >
        {/* Background glow */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0" style={{
            background: "radial-gradient(ellipse 80% 60% at 50% 120%, rgba(0,212,255,0.08) 0%, transparent 60%)"
          }} />
        </div>

        <div className="container-xl section-py relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-center max-w-3xl mx-auto"
          >
            <div className="overline-label mb-4">{overline}</div>
            <h2
              className="text-4xl sm:text-5xl font-black tracking-tighter text-white mb-4"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              {title}
            </h2>
            <p className="text-base mb-10" style={{ color: "var(--text-muted)" }}>
              {subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => setShowModal(true)}
                className="btn-primary"
                data-testid="cta-band-primary-btn"
              >
                {primaryLabel} <ArrowRight size={14} />
              </button>
              <Link
                to={secondaryHref}
                className="btn-outline"
                data-testid="cta-band-secondary-btn"
              >
                {secondaryLabel}
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <PriorityListModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}
